export default __webpack_public_path__ + "static/media/logout.64c7c731.svg";